<!--安装订单页-->
<template>
    <div style="height: 100%;width: 100%">
        <div>
            <van-sticky><!-- 粘性布局，顶部的位置固定 -->

                <div class="conopen" style="background-color: #f8f8f9">

                    <van-row type="flex" justify="space-between">
                        <van-col span="3">

                            <div style="padding: 17px">
                                <van-icon name="arrow-left" size="15px" @click="onback"/><!-- icon图标，返回路劲 -->
                            </div>
                        </van-col>
                        <van-col span="14">
                            <!-- 搜索组件 -->
                            <form action="/">
                                <van-search
                                        style="width: 100%;"
                                        v-model="value"
                                        placeholder="车牌号\车架号"
                                        show-action
                                        @search="onFind"
                                >
                                    <div slot="action" @click="onFind">搜索</div>
                                </van-search>
                            </form>
                        </van-col>
                        <van-col span="3">
                            <div style="padding: 17px">
                                <van-icon name="replay" size="15px" @click="reststart"/><!-- icon图标，刷新页面 -->
                            </div>
                        </van-col>
                        <van-col span="4">

                            <div>
                            <Dropdown placement="bottom-end">
                                <a href="javascript:void(0)">
<!--                                    下拉菜单-->
                                    <Icon type="ios-add" size="54" ></Icon>
                                </a>
                                <DropdownMenu slot="list">
                                    <a :href="'../addinstallorder?addinstall=installorder'">
                                    <DropdownItem @on-click="">新装订单</DropdownItem>
                                    </a>
<!--                                    <DropdownItem @on-click="">在网升级</DropdownItem>-->
                                </DropdownMenu>
                            </Dropdown>
<!--                                <van-icon name="plus" size="15px" @click="tosalesman"/>&lt;!&ndash; icon图标，创建订单页面 &ndash;&gt;-->
                            </div>
                        </van-col>
                    </van-row>

                </div>
                <div>
                    <!-- 下拉菜单 -->
                    <van-dropdown-menu>
                        <van-dropdown-item v-model="value1" :options="option1" @change="open"/>
                    </van-dropdown-menu>
                </div>
            </van-sticky>
        </div>
        <div style="background-color: #f8f8f9">
            <van-pull-refresh v-model="isLoading" @refresh="refresh"><!-- 下拉刷新 -->
                <!-- 上拉加载 -->
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <!-- 加载图标 -->
                    <van-loading class="loader" v-if="loader"/>
                    <div v-for="(item,index) in installlist" class="content">
                        <Card style="width:100%">
                            <cell size="small" style="padding: 0px;">
                                <label>订单号：
                                    <label style="color: #0077aa;">{{item.orderNum}}</label>
                                </label><br/>
                            </cell>

                            <div class="mid">
                                <span class="count fl">车牌号:
                                    <label style="color: #0077aa;">{{item.vehicleInfo==null?item.tempVehicleInfo.registrationNum:item.vehicleInfo.registrationNum}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                                <span class="distance fr">|</span>
                                <span class="time fr">车架号:
                                    <label style="color: #0077aa;">{{item.vehicleInfo==null?item.tempVehicleInfo.vin:item.vehicleInfo.vin}}</label>
                                </span>
                            </div>
                            <div class="mid">
                                <span class="count fl">发动机号:
                                    <label style="color: #0077aa;">{{item.vehicleInfo==null?item.tempVehicleInfo.engineNum:item.vehicleInfo.engineNum}}</label>
                                </span>
                            </div>

                            <div class="mid">
                                <span class="count fl">服务到期时间:<label style="color: #0077aa;">{{item.serviceDatetime == null? '无':new Date(item.serviceDatetime).Format('yyyy年MM月dd日')}}</label></span>
                            </div>

                            <div class="mid">
                                <span class="count fl">客户姓名:<label style="color: #0077aa;">{{item.vehicleInfo!=null?item.vehicleInfo.clientInfo!=null?item.vehicleInfo.clientInfo.name:item.clientInfo!=null?item.clientInfo.name:'无':'无'}}</label></span>
                                <span class="distance fr">|</span>
                                <span class="count fl">客户电话:<label style="color: #0077aa;">{{item.vehicleInfo!=null?item.vehicleInfo.clientInfo!=null?item.vehicleInfo.clientInfo.phoneNum:item.clientInfo!=null?item.clientInfo.phoneNum:'无':'无'}}</label></span>
                            </div>

                            <div class="mid">
                    <span class="count fl">安装状态:<label
                            style="color: #0077aa;">{{item.installed===true?'已安装':'未安装'}}</label></span>
                                <span class="distance fr">&nbsp;|&nbsp;</span>
                                <span class="time fr">安装员:<label style="color: #0077aa;">{{item.installer===null?'未指派':item.installer.realName}}</label></span>
                            </div>
<!--                            <div class="mid">-->
<!--                                <div style="position: relative;left: 55%;">-->
<!--                                    <a :href="'../installorderdetails?installid='+item.id" style="padding-right: 5px;">-->
<!--                                        <van-button v-if="item.installed===true?false:true" size="small" type="info"-->
<!--                                                    :disabled="disabled" >订单详情-->
<!--                                        </van-button>-->
<!--                                    </a>-->
<!--                                    <a :href="'../installerinstallorderconfirm?installid='+item.id">-->
<!--                                        <van-button v-if="item.installed===true?false:true" size="small" type="info"-->
<!--                                                    :disabled="disabled">修改订单-->
<!--                                        </van-button>-->
<!--                                    </a>-->
<!--                                </div>-->
<!--                            </div>-->
                            <van-collapse class="next" v-model="activeName">
                                <van-collapse-item class="next1" :name=index>

                                    <div class="mid">
     <span class="count fl">订单状态:<label :class="[item.state===1?'s1':item.state===2?'s2':item.state===0?'s3':'s4']">
       {{item.state===1?'正在处理':item.state===2?'完成':item.state===0?'作废':'异常'}} </label></span>
                                        <span class="distance fr">|</span>
                                        <span class="time fr"> 配机:<label style="color: #0077aa;">{{item.positioningDeviceInfosCount===0?'未分配':'已分配'}}</label></span>
                                        <span class="distance fr">|</span>
                                        <span class="time fr"> 业务类型:<label style="color: #0077aa;">{{item.businessType===1?'新装':item.businessType===2?'接入':'在网升级'}}</label></span>
                                    </div>
                                    <div class="mid">
                                        <span class="count fl">业务跟进员:
                                            <label style="color: #0077aa;">{{item.businessUser.realName}}</label>
                                        </span>
                                        <span class="distance fr">|</span>
                                        <span class="count fl">销售渠道:
                                            <label style="color: #0077aa;">{{item.salesChannel==null?null:item.salesChannel.name}}</label>
                                        </span>
                                    </div>

                                    <div class="mid">
                                        <span class="count fl">上传状态:<label style="color: #0077aa;">{{item.uploadState===1?'资料不完整':item.uploadState===2?'待上传':'已上传'}}</label></span>
                                        <span class="distance fr">|</span>
                                        <span class="time fr"> 开票类型:<label style="color: #0077aa;">{{item.billType===1?'增值税发票':item.billType===2?'增值税专用发票':'增值税普通发票'}}</label></span>
                                    </div>

                                    <div class="mid">
                                        <label>缺少资料：
                                            <label style="color: red">{{item.qghyptOption===
                                                0?text1(item):item.qghyptOption===
                                                1?text2(item):text3(item)}}</label></label>&nbsp;<br>
                                        <div v-if="item.state===2||item.state===0?false:true">
                                            <van-button size="small" type="info" @click="toUploaderimage(item)">上传图片
                                            </van-button>&nbsp;&nbsp;
                                            <van-button size="small" type="info" :disabled="discern"
                                                        @click="onAnalyzeVehicleLicensePicture(item.id)">识别行驶证
                                            </van-button>
                                        </div>
                                    </div>

                                    <div class="mid">
                                        <van-button size="small" type="info" @click="onBindPositioningDevicesModal(item)">配机
                                        </van-button>&nbsp;&nbsp;
                                        <van-button size="small" type="info" @click="onBindPositioningDevicesFittingsModal(item)">配件
                                        </van-button>
                                    </div>

                                    <div class="mid">
                                        <a :href="'../installorderdetails?installid='+item.id + '&install=installorder'" style="padding-right: 5px;">
                                            <van-button size="small" type="info">订单详情
                                            </van-button>
                                        </a>
                                        &nbsp;&nbsp;
                                        <van-button size="small" type="info" @click="modifyRemark(item)">修改备注
                                        </van-button>
                                        <br>
                                        <label>备注:{{item.remark}}</label><br>
                                        <label>追加备注:
                                            <div v-if="item.installRemark!=null">
                                                <label v-for="item2 in item.installRemark.split('\r\n')">{{item2}}<br></label>
                                            </div>
                                        </label><br>
                                    </div>

                                </van-collapse-item>
                            </van-collapse>


                        </Card>
                        <div style="height: 3px"></div>
                        <!--                        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">-->
                        <!--                        </van-divider>-->
                    </div>


                </van-list>
            </van-pull-refresh>
        </div>
        <div>
            <Modal
                    v-model="modal1"
                    title="添加备注"
                    @on-ok="ok"
                    @on-cancel="cancel">
                <van-cell-group>
                    <van-field
                            v-model="modifyremark"
                            rows="2"
                            autosize
                            type="textarea"
                            maxlength="250"
                            placeholder="请输入备注信息"
                            show-word-limit
                    />
                </van-cell-group>
            </Modal>
        </div>
        <bind-positioning-devices-modal v-model="bindPositioningDevicesModal" :initValue="bindPositioningDevicesId"
                                        @on-success="onModifySuccess"></bind-positioning-devices-modal>
        <bind-positioning-devices-fittings-modal v-model="bindPositioningDevicesFittingsModal" :initValue="bindPositioningDevicesFittingsId"
                                                 @on-success="onModifySuccess"></bind-positioning-devices-fittings-modal>
    </div>
</template>

<script>
    import BindPositioningDevicesModal from '@/views/im/components/bind-positioning-devices-modal'
    import BindPositioningDevicesFittingsModal from '@/views/im/components/bind-positioning-devices-fittings-modal'

    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
    } from 'vant'


    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    export default {
        name: "installorder",
        components: {
            BindPositioningDevicesModal,
            BindPositioningDevicesFittingsModal,
        },
        data() {
            return {
                // 安装订单配置设备
                bindPositioningDevicesModal: false,
                bindPositioningDevicesId: null,

                // 安装订单配置定位设备配件
                bindPositioningDevicesFittingsModal: false,
                bindPositioningDevicesFittingsId: null,

                value: '',
                installlist: [],

                activeName: [],

                value1: 0,
                option1: [
                    {text: '全部订单', value: 0},
                    {text: '作废订单', value: 1},
                    {text: '已完成订单', value: 2},
                    {text: '未安装订单', value: 3},
                    {text: '未指派订单', value: 4},
                    {text: '资料不完整', value: 5},
                    {text: '资料待上传', value: 6},
                    {text: '资料已上传', value: 7},
                ],

                readonly: true,
                isLoading: false,
                loader: false,

                discern: false,

                i: [],
                list: [],
                loading: false,
                finished: false,

                modifyremark: '',
                modal1: false,
                installOrder: {
                    id: null,
                    totalAmount: null,
                    serviceDatetime: null,
                    businessUserId: null,
                    businessType: null,
                    multiDevices: false,
                    qghyptOption: 0,
                    clientInfoId: null,
                    history: null,
                    installerId: null,
                    installer: null,
                    remark: null,
                    receptDatetime: null,
                    billType: 1
                },
            }
        },
        // handler: function (e) {
        //     e.preventDefault()
        // },

        methods: {
            //进入订单详情
            toorderDetails(e) {
                console.log(e)
                this.$router.push({
                    name: 'installorderdetails',
                    params: {'installid': e.id}
                })
            },

            //修改备注
            modifyRemark(e) {
                if (e.remark == null) {
                    this.modifyremark = ''
                }else {
                    this.modifyremark = e.remark
                }
                this.modal1 = true
                this.installOrder.id = e.id
                this.installOrder.totalAmount = e.totalAmount
                this.installOrder.serviceDatetime = e.serviceDatetime === null ? null : new Date(e.serviceDatetime)
                this.installOrder.businessUserId = e.businessUserId
                this.installOrder.businessType = e.businessType
                this.installOrder.multiDevices = e.multiDevices
                this.installOrder.qghyptOption = e.qghyptOption
                this.installOrder.history = e.history
                this.installOrder.receptDatetime = e.receptDatetime === null ? null : new Date(e.receptDatetime)
                this.installOrder.billType = e.billType
            },
            ok() {
                console.log(this.installlist)
                this.installOrder.remark = this.modifyremark
                store.dispatch('InstallOrderServ_ModifyInstallOrderBase', {
                    params: this.installOrder,
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.onFind()
                }).catch((err) => {
                    console.log(err)
                })
            },
            //添加备注取消
            cancel() {
            },
            reststart() {
                // <!-- icon图标刷新方法 -->
                this.loader = true
                setTimeout(() => {
                    // this.onFind()
                    this.i = []
                    this.installlist = []
                    this.finished = false;
                    this.onLoad()
                    this.loader = false
                }, 500)
            },
            // <!-- 上拉加载方法 -->
            onLoad() {
                this.i.push(1)
                // this.installlist = []


                if (this.value1 == 0) {
                    // setTimeout(() => {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('state', 'NEQ', 0))
                    //获取我的业务安装订单分页
                    store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    })
                        .catch((err) => {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;
                            Toast(err)
                            console.log(err)
                        })

                    // }, 500);
                } else if (this.value1 == 1) {
                    // setTimeout(() => {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('state', 'EQ', 0))
                    //获取我的业务安装订单分页
                    store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    })
                        .catch((err) => {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;
                            Toast(err)
                            console.log(err)
                        })

                    // }, 500);
                } else if (this.value1 == 2) {
                    // setTimeout(() => {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('state', 'EQ', 2))
                    aa.push(genQueryParam('state', 'NEQ', 0))
                    //获取我的业务安装订单分页
                    store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    })
                        .catch((err) => {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;
                            Toast(err)
                            console.log(err)
                        })

                    // }, 500);
                } else if (this.value1 == 3) {
                    // setTimeout(() => {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('installed', 'EQBOOL', false))
                    aa.push(genQueryParam('state', 'NEQ', 0))
                    //获取我的业务安装订单分页
                    store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    })
                        .catch((err) => {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;
                            Toast(err)
                            console.log(err)
                        })

                    // }, 500);
                } else if (this.value1 == 4) {
                    // setTimeout(() => {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('installer', 'EQNULL'))
                    aa.push(genQueryParam('state', 'NEQ', 0))
                    //获取我的业务安装订单分页
                    store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    })
                        .catch((err) => {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;
                            Toast(err)
                            console.log(err)
                        })

                    // }, 500);
                } else if (this.value1 == 5) {
                    // setTimeout(() => {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('uploadState', 'EQ', 1))
                    aa.push(genQueryParam('state', 'NEQ', 0))
                    //获取我的业务安装订单分页
                    store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    })
                        .catch((err) => {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;
                            Toast(err)
                            console.log(err)
                        })

                    // }, 500);
                } else if (this.value1 == 6) {
                    // setTimeout(() => {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('uploadState', 'EQ', 2))
                    aa.push(genQueryParam('state', 'NEQ', 0))
                    //获取我的业务安装订单分页
                    store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    })
                        .catch((err) => {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;
                            Toast(err)
                            console.log(err)
                        })

                    // }, 500);
                } else if (this.value1 == 7) {
                    // setTimeout(() => {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('uploadState', 'EQ', 3))
                    aa.push(genQueryParam('state', 'NEQ', 0))
                    //获取我的业务安装订单分页
                    store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    })
                        .catch((err) => {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;
                            Toast(err)
                            console.log(err)
                        })

                    // }, 500);
                }

            },
            // <!-- 下拉刷新方法 -->
            refresh() {
                setTimeout(() => {
                    // this.onFind()
                    this.i = []
                    this.installlist = []
                    this.finished = false;
                    this.onLoad()
                    this.isLoading = false;
                }, 500);

            },
            // <!-- icon返回路劲 -->
            onback() {
                this.$router.push({
                    name: 'myMenu'
                })
            },
            // <!-- icon创建订单路劲 -->
            tosalesman() {
                this.$router.push({
                    name: 'salesman'
                })
            },
            // <!-- 下拉菜单方法 -->
            open(e) {
                this.i = []
                this.installlist = []
                this.finished = false;
                this.onLoad()
                // console.log(e)
                // if (e === 0) {
                //     this.start()
                // } else if (e === 1) {
                //     this.onabnormal()
                // } else if (e === 2) {
                //     this.onfinish()
                // } else if (e === 3) {
                //     this.oninstalled()
                // } else if (e === 4) {
                //     this.oninstaller()
                // } else if (e === 5) {
                //     this.onuploadState()
                // } else if (e === 6) {
                //     this.onToupload()
                // } else if (e === 7) {
                //     this.onupload()
                // }

            },
            //作废订单
            onabnormal() {
                let qq = []
                qq.push(genQueryParam('state', 'EQ', 0))
                //获取我的业务安装订单分页
                store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                    params: null,
                    urlparams: {
                        q: qq,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    this.installlist = res.data.content
                })
                    .catch((err) => {
                        Toast(err)
                    })
            },
            //已完成订单
            onfinish() {
                let qq = []
                qq.push(genQueryParam('state', 'EQ', 2))
                qq.push(genQueryParam('state', 'NEQ', 0))
                //获取我的业务安装订单分页
                store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                    params: null,
                    urlparams: {
                        q: qq,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    this.installlist = res.data.content
                })
                    .catch((err) => {
                        Toast(err)
                    })
            },
            //未安装订单
            oninstalled() {
                let qq = []
                qq.push(genQueryParam('installed', 'EQBOOL', false))
                qq.push(genQueryParam('state', 'NEQ', 0))
                //获取我的业务安装订单分页
                store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                    params: null,
                    urlparams: {
                        q: qq,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    this.installlist = res.data.content
                })
                    .catch((err) => {
                        Toast(err)
                    })
            },
            //未指派订单
            oninstaller() {
                let qq = []
                qq.push(genQueryParam('installer', 'EQNULL'))
                qq.push(genQueryParam('state', 'NEQ', 0))
                //获取我的业务安装订单分页
                store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                    params: null,
                    urlparams: {
                        q: qq,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    this.installlist = res.data.content
                })
                    .catch((err) => {
                        Toast(err)
                    })
            },
            //资料不完整订单
            onuploadState() {
                let qq = []
                qq.push(genQueryParam('uploadState', 'EQ', 1))
                qq.push(genQueryParam('state', 'NEQ', 0))
                //获取我的业务安装订单分页
                store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                    params: null,
                    urlparams: {
                        q: qq,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    this.installlist = res.data.content
                })
                    .catch((err) => {
                        Toast(err)
                    })
            },
            //资料待上传订单
            onToupload() {
                let qq = []
                qq.push(genQueryParam('uploadState', 'EQ', 2))
                qq.push(genQueryParam('state', 'NEQ', 0))
                //获取我的业务安装订单分页
                store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                    params: null,
                    urlparams: {
                        q: qq,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    this.installlist = res.data.content
                })
                    .catch((err) => {
                        Toast(err)
                    })
            },
            //资料已上传订单
            onupload() {
                let qq = []
                qq.push(genQueryParam('uploadState', 'EQ', 3))
                qq.push(genQueryParam('state', 'NEQ', 0))
                //获取我的业务安装订单分页
                store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                    params: null,
                    urlparams: {
                        q: qq,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    this.installlist = res.data.content
                })
                    .catch((err) => {
                        Toast(err)
                    })
            },

            //上传图片路径
            toUploaderimage(e) {
                console.log(e)
                this.$root.installid = e
                this.$router.push({
                    path: '/Uploaderimage',
                    query: {'item': e.id,'install': 'installorder'}

                    // name: 'Uploaderimage',
                    // params: {'item': e.id,'install': 'installorder'}
                })
            },
            //缺少资料文字转换
            text1(item) {
                // if (item.vehicleInfo) {
                //     let text = ''
                //     if (!item.vehicleInfo.vehicleLicensePictureId) {
                //         text = ' 行驶证'
                //     }
                //     if (!item.vehicleInfo.vehicleLicenseFlapPictureId) {
                //         text = text + ' 行驶证副页'
                //     }
                //     return text
                // }else {
                let text = ''
                if (item.tempVehicleInfo!=null) {
                    if (!item.tempVehicleInfo.vehicleLicensePictureId) {
                        text = ' 行驶证'
                    }
                    if (!item.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                        text = text + ' 行驶证副页'
                    }
                }
                return text
                // }
            },
            text2(item) {
                // if (item.vehicleInfo) {
                //     let text = ''
                //     if (!item.vehicleInfo.vehicleLicensePictureId) {
                //         text = ' 行驶证'
                //     }
                //     if (!item.vehicleInfo.vehicleLicenseFlapPictureId) {
                //         text = text + ' 行驶证副页'
                //     }
                //     if (!item.vehicleInfo.vehicleSrcLicensePicture1Id) {
                //         text = text + ' 登记证1'
                //     }
                //     return text
                // }else {
                let text = ''
                if (item.tempVehicleInfo!=null) {
                    if (!item.tempVehicleInfo.vehicleLicensePictureId) {
                        text = ' 行驶证'
                    }
                    if (!item.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                        text = text + ' 行驶证副页'
                    }
                    if (!item.tempVehicleInfo.vehicleSrcLicensePicture1Id) {
                        text = text + ' 登记证1'
                    }
                }
                return text
                // }
            },
            text3(item) {
                // if (item.vehicleInfo) {
                //     let text = ''
                //     if (!item.vehicleInfo.vehicleLicensePictureId) {
                //         text = ' 行驶证'
                //     }
                //     if (!item.vehicleInfo.vehicleLicenseFlapPictureId) {
                //         text = text + ' 行驶证副页'
                //     }
                //     if (!item.vehicleInfo.vehicleSrcLicensePicture1Id) {
                //         text = text + ' 登记证1'
                //     }
                //     if (!item.vehicleInfo.idFilePictureId) {
                //         text = text + ' 身份识别文件'
                //     }
                //     if (!item.vehicleInfo.qghyptChangeContractPictureId) {
                //         text = text + ' 转网合同'
                //     }
                //     if (!item.vehicleInfo.qghyptChangeAuthorizationPictureId) {
                //         text = text + ' 授权书'
                //     }
                //     return text
                // }else {
                let text = ''
                if (item.tempVehicleInfo!=null) {
                    if (!item.tempVehicleInfo.vehicleLicensePictureId) {
                        text = ' 行驶证'
                    }
                    if (!item.tempVehicleInfo.vehicleLicenseFlapPictureId) {
                        text = text + ' 行驶证副页'
                    }
                    if (!item.tempVehicleInfo.vehicleSrcLicensePicture1Id) {
                        text = text + ' 登记证1'
                    }
                    if (!item.tempVehicleInfo.idFilePictureId) {
                        text = text + ' 身份识别文件'
                    }
                    if (!item.tempVehicleInfo.qghyptChangeContractPictureId) {
                        text = text + ' 转网合同'
                    }
                    if (!item.tempVehicleInfo.qghyptChangeAuthorizationPictureId) {
                        text = text + ' 授权书'
                    }
                }
                return text
                // }
            },

            // <!-- 搜索方法，默认state不为0，排除作废订单 -->
            onFind() {
                this.i = []
                this.installlist = []
                this.finished = false;
                this.onLoad()
                // if (this.value1 == 0) {
                //     let qq = []
                //     qq.push(genQueryParam('state', 'NEQ', 0))
                //     //获取我的业务安装订单分页
                //     store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                //         params: null,
                //         urlparams: {
                //             q: qq,
                //             keyword: this.value,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.installlist = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // } else if (this.value1 == 1) {
                //     let qq = []
                //     qq.push(genQueryParam('state', 'EQ', 0))
                //     //获取我的业务安装订单分页
                //     store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                //         params: null,
                //         urlparams: {
                //             q: qq,
                //             keyword: this.value,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.installlist = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // } else if (this.value1 == 2) {
                //     let qq = []
                //     qq.push(genQueryParam('state', 'EQ', 2))
                //     qq.push(genQueryParam('state', 'NEQ', 0))
                //     //获取我的业务安装订单分页
                //     store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                //         params: null,
                //         urlparams: {
                //             q: qq,
                //             keyword: this.value,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.installlist = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // } else if (this.value1 == 3) {
                //     let qq = []
                //     qq.push(genQueryParam('installed', 'EQBOOL', false))
                //     qq.push(genQueryParam('state', 'NEQ', 0))
                //     //获取我的业务安装订单分页
                //     store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                //         params: null,
                //         urlparams: {
                //             q: qq,
                //             keyword: this.value,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.installlist = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // } else if (this.value1 == 4) {
                //     let qq = []
                //     qq.push(genQueryParam('installer', 'EQNULL'))
                //     qq.push(genQueryParam('state', 'NEQ', 0))
                //     //获取我的业务安装订单分页
                //     store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                //         params: null,
                //         urlparams: {
                //             q: qq,
                //             keyword: this.value,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.installlist = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // } else if (this.value1 == 5) {
                //     let qq = []
                //     qq.push(genQueryParam('uploadState', 'EQ', 1))
                //     qq.push(genQueryParam('state', 'NEQ', 0))
                //     //获取我的业务安装订单分页
                //     store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                //         params: null,
                //         urlparams: {
                //             q: qq,
                //             keyword: this.value,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.installlist = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // } else if (this.value1 == 6) {
                //     let qq = []
                //     qq.push(genQueryParam('uploadState', 'EQ', 2))
                //     qq.push(genQueryParam('state', 'NEQ', 0))
                //     //获取我的业务安装订单分页
                //     store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                //         params: null,
                //         urlparams: {
                //             q: qq,
                //             keyword: this.value,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.installlist = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // } else if (this.value1 == 7) {
                //     let qq = []
                //     qq.push(genQueryParam('uploadState', 'EQ', 3))
                //     qq.push(genQueryParam('state', 'NEQ', 0))
                //     //获取我的业务安装订单分页
                //     store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                //         params: null,
                //         urlparams: {
                //             q: qq,
                //             keyword: this.value,
                //             sort: genSortParam('createDatetime', false)
                //         }
                //     }).then((res) => {
                //         console.log(res)
                //         this.installlist = res.data.content
                //     })
                //         .catch((err) => {
                //             console.log(err)
                //         })
                // }
            },

            //搜索取消
            onCancel() {
                this.value = ''
                this.option1.value = 0
                this.start()
            },

            start() {
                let aa = []
                aa.push(genQueryParam('state', 'NEQ', 0))
                //获取我的业务安装订单分页
                store.dispatch('InstallOrderServ_GetMyBusinessPage', {
                    params: null,
                    urlparams: {
                        q: aa,
                        keyword: this.value,
                        sort: genSortParam('createDatetime', false)
                    }
                }).then((res) => {
                    console.log(res)
                    this.installlist = res.data.content
                })
                    .catch((err) => {
                        Toast(err);
                    })
            },


            //识别行车证
            onAnalyzeVehicleLicensePicture(e) {
                this.discern = true
                //车辆信息
                store.dispatch('InstallOrderServ_GetDetail', {
                    params: {id: e},
                    urlparams: null
                }).then((res) => {


                    if (res.data.vehicleInfoId) {
                        //已完成的订单
                        //  识别行驶证
                        store.dispatch('VehicleInfoServ_AnalyzeVehicleLicensePicture', {
                            params: {id: res.data.vehicleInfoId},
                            urlparams: null
                        }).then((res) => {
                            console.log(res)
                            this.discern = false
                            this.onFind()
                        }).catch((err) => {
                            Toast(err)
                            this.discern = false
                        })
                    } else {
                        //未完成的订单

                        let installOrder = store.getters.get_InstallOrder_GetDetailResult
                        this.installOrder = installOrder
                        let vehicleInfo = this.installOrder.tempVehicleInfo
                        if (vehicleInfo.vehicleLicensePicture) {
                            //  识别行驶证
                            store.dispatch('InstallOrderServ_AnalyzeVehicleLicensePicture', {
                                params: {id: e},
                                urlparams: null
                            }).then((res) => {
                                console.log(res)
                                this.discern = false
                                this.onFind()
                            }).catch((err) => {
                                Toast(err + '请重新上传');
                                // this.$Message.error(err + '请重新上传');
                                this.discern = false
                            })
                        } else {
                            Toast('未上传行驶证');
                            // this.$Message.warning('未上传行驶证');
                            this.discern = false
                        }
                    }
                }).catch((err) => {
                    console.log(err)
                    this.discern = false
                })
            },

            //配机
            onBindPositioningDevicesModal(e){
                this.bindPositioningDevicesModal = true
                this.bindPositioningDevicesId = e.id
            },
            onBindPositioningDevicesFittingsModal(e){
                this.bindPositioningDevicesFittingsId = e.id
                this.bindPositioningDevicesFittingsModal = true
            },

        },
        computed: {
            installlistcpu() {
                return this.installlist
            }
        },
        mounted() {
            this.$nextTick(() => {

                // this.start()

            })
        }
    }
</script>

<style>
    .s1 {
        color: blue;
    }

    .s2 {
        color: yellowgreen;
    }

    .s3 {
        color: blueviolet;
    }

    .s4 {
        color: red;
    }


    /*右侧内容*/
    .content {
        /*background-color: red;*/
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 15px 0 10px;
    }

    .content .name {
        font-size: 17px;
        color: #333;
        overflow: hidden;
        font-weight: bold;
        overflow: hidden;
    }

    /*月售、送达时间、距离*/
    .content .mid {
        flex: 1;
        margin-top: 7px;
        color: #666;
        font-size: 12px;
    }

    .next .next1 .next2 {
        flex: 1;
        margin-top: 0px;
        color: #666;
        font-size: 12px;
    }

    .end {
        width: 500px;
        height: 500px;
        border: 1px solid red;
        position: relative;
    }

    .conopen {
        text-align: right;
    }

    .loader {
        text-align: center;
    }

    .to-center {
        width: 200px;
        height: 200px;
        background: green;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .wrapper {
        width: 100%;
        height: 80%;
        position: absolute;
        top: 115px;
        bottom: 50px; /*关键*/
        overflow: hidden;
        z-index: 1;
    }
</style>

